module.exports = __webpack_public_path__ + "img/Gruselgefahr.faf50f9f.svg";